module.exports = __webpack_public_path__ + "img/ae.3801a1a.png";